"use strict";

import { FilmsComparedDialogModel } from '../models/filmsComparedDialogModel';

export class FilmsComparedService {
  static $inject = ['modalService'];

  constructor(modalService) {
    this.modalService = modalService;
  }

  async showFilmsComparedModal(priorFilms, locations, ssn, sDate, studyDate, savedData) {
    const model = new FilmsComparedDialogModel({
      priorFilms: priorFilms,
      locations: locations || [],
      ssn: ssn,
      sDate: sDate,
      studyDate: studyDate,
      savedData: savedData || null
    });

    const closeByButtonsClickOnly = true;

    const result = await this.modalService.showDialogWindow(
      "views/templates/modals/films-compared-modal.html",
      model,
      closeByButtonsClickOnly
    );

    if (result && !result.cancelled) {
      return {
        displayText: result.displayText || '',
        data: {
          noPriorFilmsCompared: result.noPriorFilmsCompared,
          noPriorFilmsAvailable: result.noPriorFilmsAvailable,
          reviewed: result.reviewed,
          comparedDatesNotSpecified: result.comparedDatesNotSpecified,
          comparedToStudiesDatingBack: result.comparedToStudiesDatingBack,
          toBeObtainedFrom: result.toBeObtainedFrom,
          baselineXRT: result.baselineXRT,
          baselineStudy: result.baselineStudy,
          noChange: result.noChange,
          includeCadStatement: result.includeCadStatement,
          datingBackTo: result.datingBackTo,
          obtainedFrom: result.obtainedFrom,
          obtainedFromLocationKey: result.obtainedFromLocationKey,
          selectedFilms: result.selectedFilmsForSave || (result.priorFilms ? result.priorFilms.filter(f => f.Selected).map(film => ({
            StudyDate: film.StudyDate || '',
            Ssn: film._apiData ? (film._apiData.ssn || film._apiData.Ssn || '') : '',
            SDate: film._apiData ? (film._apiData.sDate || film._apiData.SDate || '') : '',
            IsPrevMammo: film._apiData ? (film._apiData.isPrevMammo || film._apiData.IsPrevMammo || false) : false,
            PrevMammoId: film._apiData ? (film._apiData.prevMammoId || film._apiData.PrevMammoId || '') : '',
            LocationName: film.LocationToDisplay || film.DisplayText || '',
            DocId: film._apiData ? (film._apiData.docId || film._apiData.DocId || '') : ''
          })) : [])
        }
      };
    }

    return null;
  }
}




// WEBPACK FOOTER //
// ./src/scripts/services/filmsComparedService.js